<template>
  <div
    class="p-1"
    style="
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
    "
  >
    <!-- <pre>{{ datacollection.datasets[0].data }}</pre> -->
    <div class="flex-row1">
      <h4 class="text_box2_3_1">{{ header }}</h4>
      <!-- <vs-select @change="selectWater(select_water)" width="100px" v-model="select_water">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in options_graph"
          />
        </vs-select> -->
    </div>
    <br />
    <div style="position: relative; width: 100%">
      <LineChart
        v-if="datacollection"
        :width="300"
        :height="200"
        :chartdata="datacollection"
        :options="options"
      ></LineChart>
      <!-- :areaColor="colorgraph" -->
    </div>
    <div class="div_row1" style="align-items: center">
      <div
        :style="{
          width: '45px',
          'margin-left': '2%',
          'border-radius': '20px',
          'background-color': colorgraph,
          color: colorgraph,
          height: '20px',
        }"
      >
        .
      </div>
      <a v-if="['Rain Volume Trend'].includes(header)" class="ml-1">Rain Volume</a>
       <a v-else class="ml-1">Water Level</a>
      <vs-spacer />
      <div class="item-flex">
        <div class="mr-4">
          <p style="color: #fc8200" class="mb-1">avg</p>
          <p>
            {{ avg.toFixed(2) }}
            <span v-if="['Rain Volume Trend'].includes(header)">mm./min</span
            ><span v-else>MSL</span>
          </p>
        </div>
        <div class="mr-4">
          <p style="color: #ff006a" class="mb-1">min</p>
          <p>
            {{ min.toFixed(2) }}
            <span v-if="['Rain Volume Trend'].includes(header)">mm./min</span
            ><span v-else>MSL</span>
          </p>
        </div>
        <div class="mr-4">
          <p style="color: #d400ff" class="mb-1">max</p>
          <p>
            {{ max.toFixed(2) }}
            <span v-if="['Rain Volume Trend'].includes(header)">mm./min</span
            ><span v-else>MSL</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import displaychart from "./../chart1.vue";
import LineChart from "@/components/ChartJs/LineChart.vue";
export default {
  components: { displaychart, LineChart },
  props: ["header", "items_sensor", "colorgraph", "datacollection"],
  data: () => ({
    color: ["#A1DE96", "#b38dff"],
    max: 0,
    min: 0,
    avg: 0,
    chartdata: {
      labels: ["8 pm", "9 pm", "10 pm", "11 pm", "12 pm", "1 am", "2 am"],
      value: [22, 19, 22, 11, 16, 11, 10],
      value2: [10, 14, 13, 15, 11, 24, 18],
    },
    options_graph: [
      { text: "Daily", value: 1 },
      { text: "Monthly", value: 2 },
      { text: "Yearly", value: 3 },
    ],
    options: {
      maintainAspectRatio: false,
      responsive: true,
      legend: {
        display: false,
      },
      scales: {
        yAxes: [
          {
            id: "A",
            ticks: {
              beginAtZero: true,
              // stepSize: 0.5,
              // max: 3.5,
              // min: -4.5,
            },
            position: "left",
            // scaleLabel: {
            //   display: true,
            //   labelString: "pH Value (pH)",
            // },
          },
        ],
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
            },
            // scaleLabel: {
            //   display: true,
            //   labelString: "Timestamp",
            // },
          },
        ],
      },
    },
  }),
  methods: {
    findValue(item) {
      let total = 0;
      let arr = [];
      item.forEach((element) => {
        arr.push(parseFloat(element));
      });
      this.max = Math.max.apply(Math, arr);
      this.min = Math.min.apply(Math, arr);
      for (var i = 0; i < arr.length; i++) {
        total += arr[i];
      }
      this.avg = total / arr.length;
    },
  },
  mounted() {
    this.findValue(this.datacollection.datasets[0].data);
  },
  watch: {
    dataWC: {
      // watch it
      handler() {
        // console.log("redraw chart dataWC");

        this.findValue(this.datacollection.datasets[0].data);
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.div_row1 {
  display: flex;
  flex-direction: row;
  /* margin-bottom: 10px; */
}
.item-flex {
  display: flex;
  /* justify-content: center; */
}
.text_box2_3_1 {
  margin-left: 10px;
  font-size: 1rem;
  font-weight: 600;
  color: #707070;
}
.flex-row1 {
  display: flex;
  margin-top: 10px;
  justify-content: space-between;
}
@media only screen and (max-width: 700px) {
}
</style>